import { Group, Stack, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { DocumentService } from "../../Service/DocumentService";
import { FormatS } from "../../Service/FormatS";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";

// eslint-disable-next-line import/no-anonymous-default-export
const PositionSum = ({
  isSummable,
  profile,
  values,
  positions,
  document,
  columnStyles,
}) => {
  const { taxType, currency } = document;
  const { smallScaleBusiness } = profile;
  const [summary, setSummary] = useState();
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, document.language);

  useEffect(() => {
    setSummary(DocumentService.getDocumentSummary(document, positions, values));
  }, [document, positions, values]);

  if (!summary) {
    return null;
  }
  const {
    sum,
    discountAmount,
    sumAfterDiscount,
    vats,
    discountType,
    discountValue,
    discountDescription,
    finalNetto,
    finalBrutto,
  } = summary;

  return (
    <>
      {isSummable && (
        <Stack spacing={5} mt="md" style={columnStyles.alignedContent}>
          {!smallScaleBusiness && (
            <Group position="apart">
              <Text>
                {`${t("subtotal")} (${
                  taxType === "gross" ? t("taxModeGross") : t("taxModeNet")
                })`}
              </Text>
              <Text>{FormatS.formatPriceWithCurrency(currency, sum)}</Text>
            </Group>
          )}
          {discountAmount > 0 && (
            <>
              <Group position="apart">
                <Text>
                  {" "}
                  {t("discount")}{" "}
                  {discountType === "PERCENT" && `${discountValue} %`}
                  {discountDescription && (
                    <Text span>{`(${discountDescription})`}</Text>
                  )}
                </Text>
                <Text>
                  - {FormatS.formatPriceWithCurrency(currency, discountAmount)}
                </Text>
              </Group>
              <Group position="apart">
                <Text>
                  {" "}
                  {t("totalAmount")}{" "}
                  {taxType === "gross"
                    ? t("totalAfterDiscountGross")
                    : `(${t("totalAfterDiscountNet")})`}
                </Text>
                <Text>
                  {FormatS.formatPriceWithCurrency(currency, sumAfterDiscount)}
                </Text>
              </Group>
            </>
          )}
          {vats &&
            Object.keys(vats).map((key) => {
              return (
                <Group position="apart">
                  <Text>{t("vat")} ({key}%)</Text>
                  <Text>
                    {FormatS.formatPriceWithCurrency(currency, vats[key][0])}
                  </Text>
                </Group>
              );
            })}
          {taxType === "gross" && !smallScaleBusiness && (
            <Group position="apart">
              <Text>{t("totalAmount")} ({t("taxModeNet")})</Text>
              <Text>
                {FormatS.formatPriceWithCurrency(currency, finalNetto)}
              </Text>
            </Group>
          )}
          <Group position="apart">
            <Text weight="bolder">{t("totalAmount")}</Text>
            <Text weight="bolder">
              {FormatS.formatPriceWithCurrency(
                currency,
                taxType === "net" ? finalBrutto : sumAfterDiscount
              )}
            </Text>
          </Group>
        </Stack>
      )}
    </>
  );
};

export default PositionSum;
